"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.Organigramm = void 0;
const LayoutBase_1 = require("./LayoutBase");
class RelationGroup {
    constructor(centerNodeShape, relationId, parent, nodeMap) {
        this.m_centerNodeShape = centerNodeShape;
        this.m_relationId = relationId;
        this.m_parent = parent;
        this.m_nodes = [];
        this.m_nodeShapes = [];
        this.m_nodeMap = nodeMap;
    }
    drawGroup(diagram, layout) {
        let that = this;
        let relGroup = new kendo.dataviz.diagram.Group({ autoSize: true });
        let xOffset = RelationGroup.Padding;
        let yOffset = RelationGroup.Padding;
        that.m_nodes.sort((id1, id2) => {
            let title1 = LayoutBase_1.LayoutBase.GetNodeTitle(that.m_nodeMap[id1].data.instance);
            let title2 = LayoutBase_1.LayoutBase.GetNodeTitle(that.m_nodeMap[id2].data.instance);
            return title1.localeCompare(title2);
        });
        $.each(that.m_nodes, (idx, targetNodeId) => {
            let nodeShape = layout.createNodeShape(that.m_nodeMap[targetNodeId]);
            this.m_nodeShapes.push(nodeShape);
            nodeShape.position(new kendo.dataviz.diagram.Point(xOffset, yOffset));
            relGroup.append(nodeShape.visual);
            yOffset += nodeShape.visual.drawingElement.clippedBBox().size.height + RelationGroup.InterNodeSpacing;
        });
        let relGroupSize = relGroup.drawingElement.clippedBBox().size;
        that.m_groupShape = new kendo.dataviz.diagram.Shape({
            type: "rectangle",
            editable: false,
            width: relGroupSize.width + 2 * RelationGroup.Padding,
            height: relGroupSize.height + 2 * RelationGroup.Padding,
            stroke: {
                color: "orange",
                width: RelationGroup.BorderWidth
            },
            fill: Organigramm.RelationGroupFill,
            hover: {
                fill: Organigramm.RelationGroupFillHover
            }
        });
        diagram.addShape(that.m_groupShape, false);
    }
    drawNodes(diagram, layout) {
        let that = this;
        let bbox = that.m_groupShape.visual.drawingElement.clippedBBox();
        let x = bbox.origin.x + RelationGroup.Padding;
        let y = bbox.origin.y + RelationGroup.Padding;
        $.each(that.m_nodeShapes, (idx, nodeShape) => {
            nodeShape.position(new kendo.dataviz.diagram.Point(x, y));
            diagram.addShape(nodeShape, false);
            y += nodeShape.visual.drawingElement.clippedBBox().size.height + RelationGroup.InterNodeSpacing;
            layout.setShapeDataItemProperty(nodeShape, "parentGroupShape", that.m_groupShape);
        });
    }
}
// Padding inside relation group
RelationGroup.Padding = 10;
// Spacing between nodes inside a relation group
RelationGroup.InterNodeSpacing = 5;
// Width of relation group border
RelationGroup.BorderWidth = 1;
class RelationGroupMap {
    constructor() {
        this.m_groups = {};
        this.m_numParentGroups = 0;
        this.m_numChildGroups = 0;
    }
    addEdge(centerNodeShape, centerNodeId, edge, nodeEdgeMap) {
        let edgeId = edge.data.id;
        // Both of the follwing conditions might apply (self-edge)
        if (centerNodeId === edge.data.target) {
            let groupKey = this.getGroupKey(edgeId, true);
            if (!this.m_groups[groupKey]) {
                this.m_groups[groupKey] = new RelationGroup(centerNodeShape, edgeId, true, nodeEdgeMap.nodes);
                ++this.m_numParentGroups;
            }
            this.m_groups[groupKey].m_nodes.push(edge.data.source);
        }
        if (centerNodeId === edge.data.source) {
            let groupKey = this.getGroupKey(edgeId, false);
            if (!this.m_groups[groupKey]) {
                this.m_groups[groupKey] = new RelationGroup(centerNodeShape, edgeId, false, nodeEdgeMap.nodes);
                ++this.m_numChildGroups;
            }
            this.m_groups[groupKey].m_nodes.push(edge.data.target);
        }
    }
    get allGroups() {
        let groups = [];
        for (let prop in this.m_groups)
            if (this.m_groups.hasOwnProperty(prop))
                groups.push(this.m_groups[prop]);
        return groups;
    }
    get parentGroups() { return $.grep(this.allGroups, g => g.m_parent); }
    get childGroups() { return $.grep(this.allGroups, g => !g.m_parent); }
    get numParentGroups() { return this.m_numParentGroups; }
    get numChildGroups() { return this.m_numChildGroups; }
    getGroupKey(relationId, parent) {
        return relationId + "_" + parent.toString();
    }
}
class Organigramm extends LayoutBase_1.LayoutBase {
    constructor() {
        super(...arguments);
        // Spacing between relation groups
        this.m_relationHorizontalSpacing = 20;
    }
    render(graph) {
        let that = this;
        let options = that.m_$container.data("synGraph");
        let diagram = that.m_$container.getKendoDiagram();
        diagram.zoom(1, undefined);
        // Draw center node
        let centerNodeShape = that.createNodeShape($.grep(graph.nodes, (node) => node.data.id === that.m_centerNodeId)[0]);
        diagram.addShape(centerNodeShape, false);
        let nodeEdgeMap = that.getNodesAndEdges(graph);
        let mapGroups = that.getRelationGroupMap(centerNodeShape, graph, nodeEdgeMap);
        that.renderParentGroups(centerNodeShape, diagram, nodeEdgeMap, mapGroups);
        that.renderChildGroups(centerNodeShape, diagram, nodeEdgeMap, mapGroups);
        that.drawEdgeLabels(graph, options);
        that.panToCenterNode();
    }
    getNodeWidth(options) {
        return 300;
    }
    mouseEnterShape(shape) {
        const di = shape.dataItem;
        if (di === null || di === void 0 ? void 0 : di.parentGroupShape)
            di.parentGroupShape.visual.children[0].drawingElement.fill(Organigramm.RelationGroupFillHover.color);
    }
    mouseLeaveShape(shape) {
        const di = shape.dataItem;
        if (di === null || di === void 0 ? void 0 : di.parentGroupShape)
            di.parentGroupShape.visual.children[0].drawingElement.fill(Organigramm.RelationGroupFill.color);
    }
    getNodesAndEdges(graph) {
        let map = {
            nodes: {},
            edges: {}
        };
        $.each(graph.nodes, (idx, node) => { map.nodes[node.data.id] = node; });
        $.each(graph.edges, (idx, edge) => { map.edges[edge.data.id] = edge.data; });
        return map;
    }
    // key = relId_parent
    getRelationGroupMap(centerNodeShape, graph, nodeEdgeMap) {
        let that = this;
        let groupMap = new RelationGroupMap();
        $.each(graph.edges, (idx, edge) => {
            groupMap.addEdge(centerNodeShape, that.m_centerNodeId, edge, nodeEdgeMap);
        });
        return groupMap;
    }
    renderParentGroups(centerNodeShape, diagram, nodeEdgeMap, mapGroups) {
        this.renderGroupsCore(centerNodeShape, diagram, nodeEdgeMap, mapGroups, true);
    }
    renderChildGroups(centerNodeShape, diagram, nodeEdgeMap, mapGroups) {
        this.renderGroupsCore(centerNodeShape, diagram, nodeEdgeMap, mapGroups, false);
    }
    renderGroupsCore(centerNodeShape, diagram, nodeEdgeMap, mapGroups, parent) {
        let options = this.m_$container.data("synGraph");
        const groups = parent ? mapGroups.parentGroups : mapGroups.childGroups;
        for (let i = 0; i < groups.length; ++i)
            groups[i].drawGroup(diagram, this);
        // widths of all groups + spacings between them
        let groupsCombinedWidth = 0;
        for (let i = 0; i < groups.length; ++i) {
            const clippedBBox = groups[i].m_groupShape.visual.drawingElement.clippedBBox();
            if (i < groups.length - 1)
                groupsCombinedWidth += this.m_relationHorizontalSpacing;
            groupsCombinedWidth += clippedBBox.width();
        }
        let centerNodeBBox = centerNodeShape.visual.drawingElement.clippedBBox();
        let xOff = centerNodeShape.position().x + (centerNodeBBox.width() - groupsCombinedWidth) / 2;
        let yRef = centerNodeShape.position().y;
        if (!parent)
            yRef += centerNodeBBox.height();
        for (let i = 0; i < groups.length; ++i) {
            const clippedBBox = groups[i].m_groupShape.visual.drawingElement.clippedBBox();
            let deltaY = this.m_layerSeparation;
            if (parent)
                deltaY += clippedBBox.height();
            let newY = centerNodeShape.position().y;
            if (parent)
                newY -= deltaY;
            else
                newY += deltaY;
            groups[i].m_groupShape.position(new kendo.dataviz.diagram.Point(xOff, newY));
            xOff += clippedBBox.width();
            if (i < groups.length - 1)
                xOff += this.m_relationHorizontalSpacing;
        }
        for (let i = 0; i < groups.length; ++i) {
            let connectionOptions = this.getConnectionOptions(options);
            // Draw nodes
            groups[i].drawNodes(diagram, this);
            // Draw Edges
            let sourceShape = parent ? groups[i].m_groupShape : centerNodeShape;
            let targetShape = parent ? centerNodeShape : groups[i].m_groupShape;
            let sourceBottom = sourceShape.getPosition("Bottom");
            let targetTop = targetShape.getPosition("Top");
            let midY = targetTop.y - this.m_layerSeparation / 2;
            let numGroups = parent ? mapGroups.numParentGroups : mapGroups.numChildGroups;
            let connection;
            if (numGroups === 1)
                connection = diagram.connect(sourceShape.getConnector("Bottom"), targetShape.getConnector("Top"), connectionOptions);
            else {
                connection = diagram.connect(sourceShape.getConnector("Bottom"), targetShape.getConnector("Top"), $.extend(true, connectionOptions, {
                    points: [
                        new kendo.dataviz.diagram.Point(sourceBottom.x, midY),
                        new kendo.dataviz.diagram.Point(targetTop.x, midY)
                    ]
                }));
            }
            this.setConnectionDataItemProperty(connection, "edge", nodeEdgeMap.edges[groups[i].m_relationId]);
        }
    }
}
exports.Organigramm = Organigramm;
Organigramm.RelationGroupFill = { color: "transparent" };
Organigramm.RelationGroupFillHover = { color: "orange" };
